import { useLoaderData } from "react-router-dom";
import tinycolor from 'tinycolor2';
import {
  useAppSelector,
  mapSelector,
} from '../../store';

import './Loader.scss';
import {
  ReactComponent as VisrezLogo,
} from '../../media/logos/visrez-logo-text-down.svg';

const Loader = () => {

  // Default loader bg colors (from order/brand preferences)
  const {
    loaderBgColor,
    loaderLogoBgColor,
    splashImage,
  } = useAppSelector(mapSelector);

  // Loader bg colors from embed data
  const {
    loaderBackgroundColor,
    loaderLogoBackgroundColor,
  } = useLoaderData() as {
    loaderBackgroundColor:string,
    loaderLogoBackgroundColor:string,
  };

  const loaderBg = tinycolor(loaderBackgroundColor || loaderBgColor);
  const loaderLogoBg = tinycolor(loaderLogoBackgroundColor || loaderLogoBgColor);
  const fillLogo = loaderLogoBg.isLight() ? 'black' : 'white';

  if (splashImage) {
    return (
      <div className="loader-container" style={{ backgroundColor: loaderBg.toHexString() }}>
        <div
          className="loader-box"
          style={{ backgroundColor: loaderLogoBg.toHexString() }}
        >
          <img
            className="loader-image"
            src={splashImage}
            alt="logo"
            title="Loading..."
          />
          <VisrezLogo
            className="loader-image animated bottom"
            title="Loading..."
            fill={fillLogo}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="loader-container" style={{ backgroundColor: loaderBg.toHexString() }}>
      <div
        className="loader-box"
        style={{ backgroundColor: loaderLogoBg.toHexString() }}
      >
        <VisrezLogo
          className="loader-image animated alone"
          title="Loading..."
          fill={fillLogo}
        />
      </div>
    </div>
  );
};

export default Loader;
